// extracted by mini-css-extract-plugin
module.exports = {"similar":"_32bbee5fda--similar--nsAuO","similar--top3":"_32bbee5fda--similar--top3--fr1MK","similar--colorized":"_32bbee5fda--similar--colorized--LhTcv"};